import { v4 as uuid } from 'uuid';
// OFFICE:
// independent item:
import officeBase1 from './assets/office/base-1-min.jpg';
import officeBase2 from './assets/office/base-2-min.jpg';
import officeBase3 from './assets/office/base-3-min.jpg';
import officeBase4 from './assets/office/base-4-min.jpg';
import officeBase5 from './assets/office/base-5-min.jpg';
import officeBase6 from './assets/office/base-6-min.jpg';
import officeBase7 from './assets/office/base-7-min.jpg';
import officeBase8 from './assets/office/base-8-min.jpg';

// to review every item:
import officeToShow1 from './assets/office/toShow-1-min.jpg';
import officeToShow2 from './assets/office/toShow-2-min.jpg';
import officeToShow3 from './assets/office/toShow-3-min.jpg';
import officeToShow4 from './assets/office/toShow-4-min.jpg';
import officeToShow5 from './assets/office/toShow-5-min.jpg';
import officeToShow6 from './assets/office/toShow-6-min.jpg';
import officeToShow7 from './assets/office/toShow-7-min.jpg';
import officeToShow8 from './assets/office/toShow-8-min.jpg';
import officeToShow9 from './assets/office/toShow-9-min.jpg';
import officeToShow10 from './assets/office/toShow-10-min.jpg';

// LIVING ROOM
// independent item:

import livingBase1 from './assets/living/base-1-min.jpg';
import livingBase2 from './assets/living/base-2-min.jpg';
import livingBase3 from './assets/living/base-3-min.jpg';
import livingBase4 from './assets/living/base-4-min.jpg';
import livingBase5 from './assets/living/base-5-min.jpg';
import livingBase6 from './assets/living/base-6-min.jpg';
import livingBase7 from './assets/living/base-7-min.jpg';
import livingBase8 from './assets/living/base-8-min.jpg';
// to review every item:
import livingToShow1 from './assets/living/toShow-1-min.jpg';
import livingToShow2 from './assets/living/toShow-2-min.jpg';
import livingToShow3 from './assets/living/toShow-3-min.jpg';
import livingToShow4 from './assets/living/toShow-4-min.jpg';
import livingToShow5 from './assets/living/toShow-5-min.jpg';
import livingToShow6 from './assets/living/toShow-6-min.jpg';
import livingToShow7 from './assets/living/toShow-7-min.jpg';
import livingToShow8 from './assets/living/toShow-8-min.jpg';
import livingToShow9 from './assets/living/toShow-9-min.jpg';
import livingToShow10 from './assets/living/toShow-10-min.jpg';

// ENTRYWAY
// independent item:
import entrywayBase1 from './assets/entryway/base-1-min.jpg';
import entrywayBase2 from './assets/entryway/base-2-min.jpg';
import entrywayBase3 from './assets/entryway/base-3-min.jpg';
import entrywayBase4 from './assets/entryway/base-4-min.jpg';
import entrywayBase5 from './assets/entryway/base-5-min.jpg';
import entrywayBase6 from './assets/entryway/base-6-min.jpg';
import entrywayBase7 from './assets/entryway/base-7-min.jpg';
import entrywayBase8 from './assets/entryway/base-8-min.jpg';
// to review every item:
import entrywayToShow1 from './assets/entryway/toShow-1-min.jpg';
import entrywayToShow2 from './assets/entryway/toShow-2-min.jpg';
import entrywayToShow3 from './assets/entryway/toShow-3-min.jpg';
import entrywayToShow4 from './assets/entryway/toShow-4-min.jpg';
import entrywayToShow5 from './assets/entryway/toShow-5-min.jpg';
import entrywayToShow6 from './assets/entryway/toShow-6-min.jpg';
import entrywayToShow7 from './assets/entryway/toShow-7-min.jpg';
import entrywayToShow8 from './assets/entryway/toShow-8-min.jpg';
import entrywayToShow9 from './assets/entryway/toShow-9-min.jpg';
import entrywayToShow10 from './assets/entryway/toShow-10-min.jpg';

// BED ROOM
// independent item:
import bedBase1 from './assets/bed/base-1-min.jpg';
import bedBase2 from './assets/bed/base-2-min.jpg';
import bedBase3 from './assets/bed/base-3-min.jpg';
import bedBase4 from './assets/bed/base-4-min.jpg';
import bedBase5 from './assets/bed/base-5-min.jpg';
import bedBase6 from './assets/bed/base-6-min.jpg';
import bedBase7 from './assets/bed/base-7-min.jpg';
import bedBase8 from './assets/bed/base-8-min.jpg';
// to review every item:
import bedToShow1 from './assets/bed/toShow-1-min.jpg';
import bedToShow2 from './assets/bed/toShow-2-min.jpg';
import bedToShow3 from './assets/bed/toShow-3-min.jpg';
import bedToShow4 from './assets/bed/toShow-4-min.jpg';
import bedToShow5 from './assets/bed/toShow-5-min.jpg';
import bedToShow6 from './assets/bed/toShow-6-min.jpg';
import bedToShow7 from './assets/bed/toShow-7-min.jpg';
import bedToShow8 from './assets/bed/toShow-8-min.jpg';
import bedToShow9 from './assets/bed/toShow-9-min.jpg';
import bedToShow10 from './assets/bed/toShow-10-min.jpg';

// DECOR
// independent item:
import decorBase1 from './assets/decor/base-1-min.jpg';
import decorBase2 from './assets/decor/base-2-min.jpg';
import decorBase3 from './assets/decor/base-3-min.jpg';
import decorBase4 from './assets/decor/base-4-min.jpg';
import decorBase5 from './assets/decor/base-5-min.jpg';
import decorBase6 from './assets/decor/base-6-min.jpg';
import decorBase7 from './assets/decor/base-7-min.jpg';
import decorBase8 from './assets/decor/base-8-min.jpg';
// to review every item:
import decorToShow1 from './assets/decor/toShow-1-min.jpg';
import decorToShow2 from './assets/decor/toShow-2-min.jpg';
import decorToShow3 from './assets/decor/toShow-3-min.jpg';
import decorToShow4 from './assets/decor/toShow-4-min.jpg';
import decorToShow5 from './assets/decor/toShow-5-min.jpg';
import decorToShow6 from './assets/decor/toShow-6-min.jpg';
import decorToShow7 from './assets/decor/toShow-7-min.jpg';
import decorToShow8 from './assets/decor/toShow-8-min.jpg';
import decorToShow9 from './assets/decor/toShow-9-min.jpg';
import decorToShow10 from './assets/decor/toShow-10-min.jpg';

const categories = [
  {
    id: uuid(),
    title: 'office',
    routeName: 'office',
    products: [
      {
        id: uuid(),
        name: 'office1',
        slug: 'office1',
        dispatchAs: '2-4',
        category: 'office',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: officeBase1,
        featured: false,
        price: 200,
        availableColors: [
          '#ABE188',
          '#F7EF99',
          '#F1BB87',
          '#F78E69',
          '#5D675B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          officeToShow1,
          officeToShow2,
          officeToShow3,
          officeToShow4,
          officeToShow5,
          officeToShow6,
          officeToShow7,
          officeToShow8,
          officeToShow9,
          officeToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'office2',
        slug: 'office2',
        dispatchAs: '2-4',
        category: 'office',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: officeBase2,
        featured: false,
        price: 200,
        availableColors: [
          '#ABE188',
          '#F7EF99',
          '#F1BB87',
          '#F78E69',
          '#5D675B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          officeToShow1,
          officeToShow2,
          officeToShow3,
          officeToShow4,
          officeToShow5,
          officeToShow6,
          officeToShow7,
          officeToShow8,
          officeToShow9,
          officeToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'office3',
        slug: 'office3',
        dispatchAs: '2-4',
        category: 'office',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: officeBase3,
        featured: true,
        price: 200,
        availableColors: [
          '#ABE188',
          '#F7EF99',
          '#F1BB87',
          '#F78E69',
          '#5D675B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          officeToShow1,
          officeToShow2,
          officeToShow3,
          officeToShow4,
          officeToShow5,
          officeToShow6,
          officeToShow7,
          officeToShow8,
          officeToShow9,
          officeToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'office4',
        slug: 'office4',
        dispatchAs: '2-4',
        category: 'office',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: officeBase4,
        featured: false,
        price: 200,
        availableColors: [
          '#ABE188',
          '#F7EF99',
          '#F1BB87',
          '#F78E69',
          '#5D675B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          officeToShow1,
          officeToShow2,
          officeToShow3,
          officeToShow4,
          officeToShow5,
          officeToShow6,
          officeToShow7,
          officeToShow8,
          officeToShow9,
          officeToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'office5',
        slug: 'office5',
        dispatchAs: '2-4',
        category: 'office',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: officeBase5,
        featured: false,
        price: 200,
        availableColors: [
          '#ABE188',
          '#F7EF99',
          '#F1BB87',
          '#F78E69',
          '#5D675B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          officeToShow1,
          officeToShow2,
          officeToShow3,
          officeToShow4,
          officeToShow5,
          officeToShow6,
          officeToShow7,
          officeToShow8,
          officeToShow9,
          officeToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'office6',
        slug: 'office6',
        dispatchAs: '2-4',
        category: 'office',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: officeBase6,
        featured: false,
        price: 200,
        availableColors: [
          '#ABE188',
          '#F7EF99',
          '#F1BB87',
          '#F78E69',
          '#5D675B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          officeToShow1,
          officeToShow2,
          officeToShow3,
          officeToShow4,
          officeToShow5,
          officeToShow6,
          officeToShow7,
          officeToShow8,
          officeToShow9,
          officeToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'office7',
        slug: 'office7',
        dispatchAs: '2-4',
        category: 'office',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: officeBase7,
        featured: true,
        price: 200,
        availableColors: [
          '#ABE188',
          '#F7EF99',
          '#F1BB87',
          '#F78E69',
          '#5D675B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          officeToShow1,
          officeToShow2,
          officeToShow3,
          officeToShow4,
          officeToShow5,
          officeToShow6,
          officeToShow7,
          officeToShow8,
          officeToShow9,
          officeToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'office8',
        slug: 'office8',
        dispatchAs: '2-4',
        category: 'office',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: officeBase8,
        featured: false,
        price: 200,
        availableColors: [
          '#ABE188',
          '#F7EF99',
          '#F1BB87',
          '#F78E69',
          '#5D675B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          officeToShow1,
          officeToShow2,
          officeToShow3,
          officeToShow4,
          officeToShow5,
          officeToShow6,
          officeToShow7,
          officeToShow8,
          officeToShow9,
          officeToShow10,
        ],
      },
    ],
  },
  {
    id: uuid(),
    title: 'living room',
    routeName: 'living-room',
    products: [
      {
        id: uuid(),
        name: 'living1',
        slug: 'living1',
        dispatchAs: '2-4',
        category: 'living',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: livingBase1,
        featured: false,
        price: 200,
        availableColors: [
          '#2B193D',
          '#2C365E',
          '#484D6D',
          '#4B8F8C',
          '#C5979D',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          livingToShow1,
          livingToShow2,
          livingToShow3,
          livingToShow4,
          livingToShow5,
          livingToShow6,
          livingToShow7,
          livingToShow8,
          livingToShow9,
          livingToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'living2',
        slug: 'living2',
        dispatchAs: '2-4',
        category: 'living',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: livingBase2,
        featured: false,
        price: 200,
        availableColors: [
          '#2B193D',
          '#2C365E',
          '#484D6D',
          '#4B8F8C',
          '#C5979D',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          livingToShow1,
          livingToShow2,
          livingToShow3,
          livingToShow4,
          livingToShow5,
          livingToShow6,
          livingToShow7,
          livingToShow8,
          livingToShow9,
          livingToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'living3',
        slug: 'living3',
        dispatchAs: '2-4',
        category: 'living',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: livingBase3,
        featured: false,
        price: 200,
        availableColors: [
          '#2B193D',
          '#2C365E',
          '#484D6D',
          '#4B8F8C',
          '#C5979D',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          livingToShow1,
          livingToShow2,
          livingToShow3,
          livingToShow4,
          livingToShow5,
          livingToShow6,
          livingToShow7,
          livingToShow8,
          livingToShow9,
          livingToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'living4',
        slug: 'living4',
        dispatchAs: '2-4',
        category: 'living',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: livingBase4,
        featured: false,
        price: 200,
        availableColors: [
          '#2B193D',
          '#2C365E',
          '#484D6D',
          '#4B8F8C',
          '#C5979D',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          livingToShow1,
          livingToShow2,
          livingToShow3,
          livingToShow4,
          livingToShow5,
          livingToShow6,
          livingToShow7,
          livingToShow8,
          livingToShow9,
          livingToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'living5',
        slug: 'living5',
        dispatchAs: '2-4',
        category: 'living',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: livingBase5,
        featured: false,
        price: 200,
        availableColors: [
          '#2B193D',
          '#2C365E',
          '#484D6D',
          '#4B8F8C',
          '#C5979D',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          livingToShow1,
          livingToShow2,
          livingToShow3,
          livingToShow4,
          livingToShow5,
          livingToShow6,
          livingToShow7,
          livingToShow8,
          livingToShow9,
          livingToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'living6',
        slug: 'living6',
        dispatchAs: '2-4',
        category: 'living',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: livingBase6,
        featured: false,
        price: 200,
        availableColors: [
          '#2B193D',
          '#2C365E',
          '#484D6D',
          '#4B8F8C',
          '#C5979D',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          livingToShow1,
          livingToShow2,
          livingToShow3,
          livingToShow4,
          livingToShow5,
          livingToShow6,
          livingToShow7,
          livingToShow8,
          livingToShow9,
          livingToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'living7',
        slug: 'living7',
        dispatchAs: '2-4',
        category: 'living',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: livingBase7,
        featured: false,
        price: 200,
        availableColors: [
          '#2B193D',
          '#2C365E',
          '#484D6D',
          '#4B8F8C',
          '#C5979D',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          livingToShow1,
          livingToShow2,
          livingToShow3,
          livingToShow4,
          livingToShow5,
          livingToShow6,
          livingToShow7,
          livingToShow8,
          livingToShow9,
          livingToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'living8',
        slug: 'living8',
        dispatchAs: '2-4',
        category: 'living',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: livingBase8,
        featured: true,
        price: 200,
        availableColors: [
          '#2B193D',
          '#2C365E',
          '#484D6D',
          '#4B8F8C',
          '#C5979D',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          livingToShow1,
          livingToShow2,
          livingToShow3,
          livingToShow4,
          livingToShow5,
          livingToShow6,
          livingToShow7,
          livingToShow8,
          livingToShow9,
          livingToShow10,
        ],
      },
    ],
  },
  {
    id: uuid(),
    title: 'entryway',
    routeName: 'entryway',
    products: [
      {
        id: uuid(),
        name: 'entryway1',
        slug: 'entryway1',
        dispatchAs: '2-4',
        category: 'entryway',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: entrywayBase1,
        featured: false,
        price: 200,
        availableColors: [
          '#000F08',
          '#136F63',
          '#E0CA3C',
          '#F34213',
          '#3E2F5B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          entrywayToShow1,
          entrywayToShow2,
          entrywayToShow3,
          entrywayToShow4,
          entrywayToShow5,
          entrywayToShow6,
          entrywayToShow7,
          entrywayToShow8,
          entrywayToShow9,
          entrywayToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'entryway2',
        slug: 'entryway2',
        dispatchAs: '2-4',
        category: 'entryway',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: entrywayBase2,
        featured: false,
        price: 200,
        availableColors: [
          '#000F08',
          '#136F63',
          '#E0CA3C',
          '#F34213',
          '#3E2F5B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          entrywayToShow1,
          entrywayToShow2,
          entrywayToShow3,
          entrywayToShow4,
          entrywayToShow5,
          entrywayToShow6,
          entrywayToShow7,
          entrywayToShow8,
          entrywayToShow9,
          entrywayToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'entryway3',
        slug: 'entryway3',
        dispatchAs: '2-4',
        category: 'entryway',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: entrywayBase3,
        featured: false,
        price: 200,
        availableColors: [
          '#000F08',
          '#136F63',
          '#E0CA3C',
          '#F34213',
          '#3E2F5B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          entrywayToShow1,
          entrywayToShow2,
          entrywayToShow3,
          entrywayToShow4,
          entrywayToShow5,
          entrywayToShow6,
          entrywayToShow7,
          entrywayToShow8,
          entrywayToShow9,
          entrywayToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'entryway4',
        slug: 'entryway4',
        dispatchAs: '2-4',
        category: 'entryway',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: entrywayBase4,
        featured: false,
        price: 200,
        availableColors: [
          '#000F08',
          '#136F63',
          '#E0CA3C',
          '#F34213',
          '#3E2F5B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          entrywayToShow1,
          entrywayToShow2,
          entrywayToShow3,
          entrywayToShow4,
          entrywayToShow5,
          entrywayToShow6,
          entrywayToShow7,
          entrywayToShow8,
          entrywayToShow9,
          entrywayToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'entryway5',
        slug: 'entryway5',
        dispatchAs: '2-4',
        category: 'entryway',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: entrywayBase5,
        featured: true,
        price: 200,
        availableColors: [
          '#000F08',
          '#136F63',
          '#E0CA3C',
          '#F34213',
          '#3E2F5B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          entrywayToShow1,
          entrywayToShow2,
          entrywayToShow3,
          entrywayToShow4,
          entrywayToShow5,
          entrywayToShow6,
          entrywayToShow7,
          entrywayToShow8,
          entrywayToShow9,
          entrywayToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'entryway6',
        slug: 'entryway6',
        dispatchAs: '2-4',
        category: 'entryway',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: entrywayBase6,
        featured: false,
        price: 200,
        availableColors: [
          '#000F08',
          '#136F63',
          '#E0CA3C',
          '#F34213',
          '#3E2F5B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          entrywayToShow1,
          entrywayToShow2,
          entrywayToShow3,
          entrywayToShow4,
          entrywayToShow5,
          entrywayToShow6,
          entrywayToShow7,
          entrywayToShow8,
          entrywayToShow9,
          entrywayToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'entryway7',
        slug: 'entryway7',
        dispatchAs: '2-4',
        category: 'entryway',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: entrywayBase7,
        featured: false,
        price: 200,
        availableColors: [
          '#000F08',
          '#136F63',
          '#E0CA3C',
          '#F34213',
          '#3E2F5B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          entrywayToShow1,
          entrywayToShow2,
          entrywayToShow3,
          entrywayToShow4,
          entrywayToShow5,
          entrywayToShow6,
          entrywayToShow7,
          entrywayToShow8,
          entrywayToShow9,
          entrywayToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'entryway8',
        slug: 'entryway8',
        dispatchAs: '2-4',
        category: 'entryway',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: entrywayBase8,
        featured: false,
        price: 200,
        availableColors: [
          '#000F08',
          '#136F63',
          '#E0CA3C',
          '#F34213',
          '#3E2F5B',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          entrywayToShow1,
          entrywayToShow2,
          entrywayToShow3,
          entrywayToShow4,
          entrywayToShow5,
          entrywayToShow6,
          entrywayToShow7,
          entrywayToShow8,
          entrywayToShow9,
          entrywayToShow10,
        ],
      },
    ],
  },
  {
    id: uuid(),
    title: 'bed room',
    routeName: 'bed-room',
    products: [
      {
        id: uuid(),
        name: 'bedroom1',
        slug: 'bedroom1',
        dispatchAs: '2-4',
        category: 'bedroom',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: bedBase1,
        featured: false,
        price: 200,
        availableColors: [
          '#eae2b7',
          '#fcbf49',
          '#f77f00',
          '#d62828',
          '#3a5a40',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          bedToShow1,
          bedToShow2,
          bedToShow3,
          bedToShow4,
          bedToShow5,
          bedToShow6,
          bedToShow7,
          bedToShow8,
          bedToShow9,
          bedToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'bedroom2',
        slug: 'bedroom2',
        dispatchAs: '2-4',
        category: 'bedroom',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: bedBase2,
        featured: false,
        price: 200,
        availableColors: [
          '#eae2b7',
          '#fcbf49',
          '#f77f00',
          '#d62828',
          '#3a5a40',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          bedToShow1,
          bedToShow2,
          bedToShow3,
          bedToShow4,
          bedToShow5,
          bedToShow6,
          bedToShow7,
          bedToShow8,
          bedToShow9,
          bedToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'bedroom3',
        slug: 'bedroom3',
        dispatchAs: '2-4',
        category: 'bedroom',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: bedBase3,
        featured: true,
        price: 200,
        availableColors: [
          '#eae2b7',
          '#fcbf49',
          '#f77f00',
          '#d62828',
          '#3a5a40',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          bedToShow1,
          bedToShow2,
          bedToShow3,
          bedToShow4,
          bedToShow5,
          bedToShow6,
          bedToShow7,
          bedToShow8,
          bedToShow9,
          bedToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'bedroom4',
        slug: 'bedroom4',
        dispatchAs: '2-4',
        category: 'bedroom',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: bedBase4,
        featured: false,
        price: 200,
        availableColors: [
          '#eae2b7',
          '#fcbf49',
          '#f77f00',
          '#d62828',
          '#3a5a40',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          bedToShow1,
          bedToShow2,
          bedToShow3,
          bedToShow4,
          bedToShow5,
          bedToShow6,
          bedToShow7,
          bedToShow8,
          bedToShow9,
          bedToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'bedroom5',
        slug: 'bedroom5',
        dispatchAs: '2-4',
        category: 'bedroom',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: bedBase5,
        featured: false,
        price: 200,
        availableColors: [
          '#eae2b7',
          '#fcbf49',
          '#f77f00',
          '#d62828',
          '#3a5a40',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          bedToShow1,
          bedToShow2,
          bedToShow3,
          bedToShow4,
          bedToShow5,
          bedToShow6,
          bedToShow7,
          bedToShow8,
          bedToShow9,
          bedToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'bedroom6',
        slug: 'bedroom6',
        dispatchAs: '2-4',
        category: 'bedroom',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: bedBase6,
        featured: false,
        price: 200,
        availableColors: [
          '#eae2b7',
          '#fcbf49',
          '#f77f00',
          '#d62828',
          '#3a5a40',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          bedToShow1,
          bedToShow2,
          bedToShow3,
          bedToShow4,
          bedToShow5,
          bedToShow6,
          bedToShow7,
          bedToShow8,
          bedToShow9,
          bedToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'bedroom7',
        slug: 'bedroom7',
        dispatchAs: '2-4',
        category: 'bedroom',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: bedBase7,
        featured: true,
        price: 200,
        availableColors: [
          '#eae2b7',
          '#fcbf49',
          '#f77f00',
          '#d62828',
          '#3a5a40',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          bedToShow1,
          bedToShow2,
          bedToShow3,
          bedToShow4,
          bedToShow5,
          bedToShow6,
          bedToShow7,
          bedToShow8,
          bedToShow9,
          bedToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'bedroom8',
        slug: 'bedroom8',
        dispatchAs: '2-4',
        category: 'bedroom',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: bedBase8,
        featured: false,
        price: 200,
        availableColors: [
          '#eae2b7',
          '#fcbf49',
          '#f77f00',
          '#d62828',
          '#3a5a40',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          bedToShow1,
          bedToShow2,
          bedToShow3,
          bedToShow4,
          bedToShow5,
          bedToShow6,
          bedToShow7,
          bedToShow8,
          bedToShow9,
          bedToShow10,
        ],
      },
    ],
  },
  {
    id: uuid(),
    title: 'decor',
    routeName: 'decor',
    products: [
      {
        id: uuid(),
        name: 'decor1',
        slug: 'decor1',
        dispatchAs: '2-4',
        category: 'decor',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: decorBase1,
        featured: false,
        price: 200,
        availableColors: [
          '#2A2B2A',
          '#5E4955',
          '#996888',
          '#C99DA3',
          '#C6DDF0',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          decorToShow1,
          decorToShow2,
          decorToShow3,
          decorToShow4,
          decorToShow5,
          decorToShow6,
          decorToShow7,
          decorToShow8,
          decorToShow9,
          decorToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'decor2',
        slug: 'decor2',
        dispatchAs: '2-4',
        category: 'decor',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: decorBase2,
        featured: false,
        price: 200,
        availableColors: [
          '#2A2B2A',
          '#5E4955',
          '#996888',
          '#C99DA3',
          '#C6DDF0',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          decorToShow1,
          decorToShow2,
          decorToShow3,
          decorToShow4,
          decorToShow5,
          decorToShow6,
          decorToShow7,
          decorToShow8,
          decorToShow9,
          decorToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'decor3',
        slug: 'decor3',
        dispatchAs: '2-4',
        category: 'decor',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: decorBase3,
        featured: false,
        price: 200,
        availableColors: [
          '#2A2B2A',
          '#5E4955',
          '#996888',
          '#C99DA3',
          '#C6DDF0',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          decorToShow1,
          decorToShow2,
          decorToShow3,
          decorToShow4,
          decorToShow5,
          decorToShow6,
          decorToShow7,
          decorToShow8,
          decorToShow9,
          decorToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'decor4',
        slug: 'decor4',
        dispatchAs: '2-4',
        category: 'decor',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: decorBase4,
        featured: false,
        price: 200,
        availableColors: [
          '#2A2B2A',
          '#5E4955',
          '#996888',
          '#C99DA3',
          '#C6DDF0',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          decorToShow1,
          decorToShow2,
          decorToShow3,
          decorToShow4,
          decorToShow5,
          decorToShow6,
          decorToShow7,
          decorToShow8,
          decorToShow9,
          decorToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'decor5',
        slug: 'decor5',
        dispatchAs: '2-4',
        category: 'decor',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: decorBase5,
        featured: true,
        price: 200,
        availableColors: [
          '#2A2B2A',
          '#5E4955',
          '#996888',
          '#C99DA3',
          '#C6DDF0',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          decorToShow1,
          decorToShow2,
          decorToShow3,
          decorToShow4,
          decorToShow5,
          decorToShow6,
          decorToShow7,
          decorToShow8,
          decorToShow9,
          decorToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'decor6',
        slug: 'decor6',
        dispatchAs: '2-4',
        category: 'decor',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: decorBase6,
        featured: false,
        price: 200,
        availableColors: [
          '#2A2B2A',
          '#5E4955',
          '#996888',
          '#C99DA3',
          '#C6DDF0',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          decorToShow1,
          decorToShow2,
          decorToShow3,
          decorToShow4,
          decorToShow5,
          decorToShow6,
          decorToShow7,
          decorToShow8,
          decorToShow9,
          decorToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'decor7',
        slug: 'decor7',
        dispatchAs: '2-4',
        category: 'decor',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: decorBase7,
        featured: false,
        price: 200,
        availableColors: [
          '#2A2B2A',
          '#5E4955',
          '#996888',
          '#C99DA3',
          '#C6DDF0',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          decorToShow1,
          decorToShow2,
          decorToShow3,
          decorToShow4,
          decorToShow5,
          decorToShow6,
          decorToShow7,
          decorToShow8,
          decorToShow9,
          decorToShow10,
        ],
      },
      {
        id: uuid(),
        name: 'decor8',
        slug: 'decor8',
        dispatchAs: '2-4',
        category: 'decor',
        simiDesc: 'Partially solid rubber tree - walnutiii',
        provisional: 'Jan 27th - Feb 2nd',
        sippingAs: 'package',
        wished: false,
        description:
          'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
        onlineReturnPolicy:
          'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
        imgUrl: decorBase8,
        featured: false,
        price: 200,
        availableColors: [
          '#2A2B2A',
          '#5E4955',
          '#996888',
          '#C99DA3',
          '#C6DDF0',
        ],
        details: [
          'W 47.2" x D 23.6" x H 17.7"',
          'High Gloss Black or White Lacquer Finish Top',
          'Polished Stainless Steel Base',
          'Matching End Table Available',
          '51 LBS',
        ],
        returnAndExchange: true,
        freeShipping: true,
        images: [
          decorToShow1,
          decorToShow2,
          decorToShow3,
          decorToShow4,
          decorToShow5,
          decorToShow6,
          decorToShow7,
          decorToShow8,
          decorToShow9,
          decorToShow10,
        ],
      },
    ],
  },
];

// limited and new
const limitedAndNew = [
  {
    id: uuid(),
    name: 'office2',
    slug: 'office2',
    dispatchAs: '2-4',
    category: 'office',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: officeBase2,
    featured: false,
    price: 200,
    availableColors: ['#ABE188', '#F7EF99', '#F1BB87', '#F78E69', '#5D675B'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      officeToShow1,
      officeToShow2,
      officeToShow3,
      officeToShow4,
      officeToShow5,
      officeToShow6,
      officeToShow7,
      officeToShow8,
      officeToShow9,
      officeToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'office4',
    slug: 'office4',
    dispatchAs: '2-4',
    category: 'office',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: officeBase4,
    featured: false,
    price: 200,
    availableColors: ['#ABE188', '#F7EF99', '#F1BB87', '#F78E69', '#5D675B'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      officeToShow1,
      officeToShow2,
      officeToShow3,
      officeToShow4,
      officeToShow5,
      officeToShow6,
      officeToShow7,
      officeToShow8,
      officeToShow9,
      officeToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'living1',
    slug: 'living1',
    dispatchAs: '2-4',
    category: 'living',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: livingBase1,
    featured: false,
    price: 200,
    availableColors: ['#2B193D', '#2C365E', '#484D6D', '#4B8F8C', '#C5979D'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      livingToShow1,
      livingToShow2,
      livingToShow3,
      livingToShow4,
      livingToShow5,
      livingToShow6,
      livingToShow7,
      livingToShow8,
      livingToShow9,
      livingToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'living3',
    slug: 'living3',
    dispatchAs: '2-4',
    category: 'living',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: livingBase3,
    featured: false,
    price: 200,
    availableColors: ['#2B193D', '#2C365E', '#484D6D', '#4B8F8C', '#C5979D'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      livingToShow1,
      livingToShow2,
      livingToShow3,
      livingToShow4,
      livingToShow5,
      livingToShow6,
      livingToShow7,
      livingToShow8,
      livingToShow9,
      livingToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'living6',
    slug: 'living6',
    dispatchAs: '2-4',
    category: 'living',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: livingBase6,
    featured: false,
    price: 200,
    availableColors: ['#2B193D', '#2C365E', '#484D6D', '#4B8F8C', '#C5979D'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      livingToShow1,
      livingToShow2,
      livingToShow3,
      livingToShow4,
      livingToShow5,
      livingToShow6,
      livingToShow7,
      livingToShow8,
      livingToShow9,
      livingToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'living7',
    slug: 'living7',
    dispatchAs: '2-4',
    category: 'living',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: livingBase7,
    featured: false,
    price: 200,
    availableColors: ['#2B193D', '#2C365E', '#484D6D', '#4B8F8C', '#C5979D'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      livingToShow1,
      livingToShow2,
      livingToShow3,
      livingToShow4,
      livingToShow5,
      livingToShow6,
      livingToShow7,
      livingToShow8,
      livingToShow9,
      livingToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'entryway2',
    slug: 'entryway2',
    dispatchAs: '2-4',
    category: 'entryway',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: entrywayBase2,
    featured: false,
    price: 200,
    availableColors: ['#000F08', '#136F63', '#E0CA3C', '#F34213', '#3E2F5B'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      entrywayToShow1,
      entrywayToShow2,
      entrywayToShow3,
      entrywayToShow4,
      entrywayToShow5,
      entrywayToShow6,
      entrywayToShow7,
      entrywayToShow8,
      entrywayToShow9,
      entrywayToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'entryway3',
    slug: 'entryway3',
    dispatchAs: '2-4',
    category: 'entryway',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: entrywayBase3,
    featured: false,
    price: 200,
    availableColors: ['#000F08', '#136F63', '#E0CA3C', '#F34213', '#3E2F5B'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      entrywayToShow1,
      entrywayToShow2,
      entrywayToShow3,
      entrywayToShow4,
      entrywayToShow5,
      entrywayToShow6,
      entrywayToShow7,
      entrywayToShow8,
      entrywayToShow9,
      entrywayToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'bedroom6',
    slug: 'bedroom6',
    dispatchAs: '2-4',
    category: 'bedroom',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: bedBase6,
    featured: false,
    price: 200,
    availableColors: ['#eae2b7', '#fcbf49', '#f77f00', '#d62828', '#3a5a40'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      bedToShow1,
      bedToShow2,
      bedToShow3,
      bedToShow4,
      bedToShow5,
      bedToShow6,
      bedToShow7,
      bedToShow8,
      bedToShow9,
      bedToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'bedroom7',
    slug: 'bedroom7',
    dispatchAs: '2-4',
    category: 'bedroom',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: bedBase7,
    featured: false,
    price: 200,
    availableColors: ['#eae2b7', '#fcbf49', '#f77f00', '#d62828', '#3a5a40'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      bedToShow1,
      bedToShow2,
      bedToShow3,
      bedToShow4,
      bedToShow5,
      bedToShow6,
      bedToShow7,
      bedToShow8,
      bedToShow9,
      bedToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'decor7',
    slug: 'decor7',
    dispatchAs: '2-4',
    category: 'decor',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: decorBase7,
    featured: false,
    price: 200,
    availableColors: ['#2A2B2A', '#5E4955', '#996888', '#C99DA3', '#C6DDF0'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      decorToShow1,
      decorToShow2,
      decorToShow3,
      decorToShow4,
      decorToShow5,
      decorToShow6,
      decorToShow7,
      decorToShow8,
      decorToShow9,
      decorToShow10,
    ],
  },
  {
    id: uuid(),
    name: 'decor8',
    slug: 'decor8',
    dispatchAs: '2-4',
    category: 'decor',
    simiDesc: 'Partially solid rubber tree - walnutiii',
    provisional: 'Jan 27th - Feb 2nd',
    sippingAs: 'package',
    wished: false,
    description:
      'Stunning elegance and a floating desktop define the elite 79-inch Ford Desk. The finish is a smooth black stain over an American oak wood veneer. This is accented with silver painted wood feet and risers plus a black panel on top with ports for wire management. It features four drawers with ball bearing slides for ample and effortless storage at your fingertips. Each pedestal features a dual lock with a top drawer for general storage and the lower drawer with filing that fits both letter and legal files. To finish it off there is a wide keyboard tray that can also double as a notepad storage. Please note: Credenza shown is sold separately.',
    onlineReturnPolicy:
      'We offer 30 days from delivery for an exchange or refund, less original delivery fees on select items. For full return policy information, please click here.',
    imgUrl: decorBase8,
    featured: true,
    price: 200,
    availableColors: ['#2A2B2A', '#5E4955', '#996888', '#C99DA3', '#C6DDF0'],
    details: [
      'W 47.2" x D 23.6" x H 17.7"',
      'High Gloss Black or White Lacquer Finish Top',
      'Polished Stainless Steel Base',
      'Matching End Table Available',
      '51 LBS',
    ],
    returnAndExchange: true,
    freeShipping: true,
    images: [
      decorToShow1,
      decorToShow2,
      decorToShow3,
      decorToShow4,
      decorToShow5,
      decorToShow6,
      decorToShow7,
      decorToShow8,
      decorToShow9,
      decorToShow10,
    ],
  },
];

export { categories, limitedAndNew };
